import DOMPurify from 'dompurify';

// Rich text (TinyMCE) stored server-side is user-controlled: strip scripts,
// event handlers and javascript: URLs before handing it to
// dangerouslySetInnerHTML. HTML profile only — no SVG/MathML.
export const sanitizeHtml = html => DOMPurify.sanitize(String(html ?? ''), { USE_PROFILES: { html: true } });

// Safe counterpart of helpers/createMarkup.
const sanitizedMarkup = html => ({ __html: sanitizeHtml(html) });

export default sanitizedMarkup;
